var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformacionPersonal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 10C9.91993 10 11.375 8.50762 11.375 6.66667C11.375 4.82572 9.91993 3.33333 8.125 3.33333C6.33007 3.33333 4.875 4.82572 4.875 6.66667C4.875 8.50762 6.33007 10 8.125 10Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 5.83333C14.625 5.3731 14.9888 5 15.4375 5H21.9375C22.3862 5 22.75 5.3731 22.75 5.83333C22.75 6.29357 22.3862 6.66667 21.9375 6.66667H15.4375C14.9888 6.66667 14.625 6.29357 14.625 5.83333Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 10C14.625 9.53976 14.9888 9.16667 15.4375 9.16667H21.9375C22.3862 9.16667 22.75 9.53976 22.75 10C22.75 10.4602 22.3862 10.8333 21.9375 10.8333H15.4375C14.9888 10.8333 14.625 10.4602 14.625 10Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 14.1667C16.25 13.7064 16.6138 13.3333 17.0625 13.3333H21.9375C22.3862 13.3333 22.75 13.7064 22.75 14.1667C22.75 14.6269 22.3862 15 21.9375 15H17.0625C16.6138 15 16.25 14.6269 16.25 14.1667Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 0C1.45507 0 0 1.49238 0 3.33333V16.6667C0 18.5076 1.45508 20 3.25 20H22.75C24.5449 20 26 18.5076 26 16.6667V3.33333C26 1.49238 24.5449 0 22.75 0H3.25ZM1.625 3.33333C1.625 2.41286 2.35254 1.66667 3.25 1.66667H22.75C23.6475 1.66667 24.375 2.41286 24.375 3.33333V16.6667C24.375 17.5871 23.6475 18.3333 22.75 18.3333H14.5592C14.6026 18.0612 14.625 17.7829 14.625 17.5C14.625 14.2783 11.7149 11.6667 8.125 11.6667C4.73474 11.6667 1.9507 13.996 1.6516 16.9686C1.63413 16.8707 1.625 16.7698 1.625 16.6667V3.33333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformacionPersonal);
export default __webpack_public_path__ + "static/media/informacionPersonal.68d9bff368abb55873bbf6b2496acf94.svg";
export { ForwardRef as ReactComponent };